/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonFileInfo,
    JsonFileInfoFromJSON,
    JsonFileInfoFromJSONTyped,
    JsonFileInfoToJSON,
} from './JsonFileInfo';

/**
 * 
 * @export
 * @interface ApiResultOfJsonFileInfo
 */
export interface ApiResultOfJsonFileInfo {
    /**
     * 
     * @type {JsonFileInfo}
     * @memberof ApiResultOfJsonFileInfo
     */
    data?: JsonFileInfo;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonFileInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonFileInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonFileInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonFileInfo
     */
    result?: ApiResultOfJsonFileInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonFileInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonFileInfoFromJSON(json: any): ApiResultOfJsonFileInfo {
    return ApiResultOfJsonFileInfoFromJSONTyped(json, false);
}

export function ApiResultOfJsonFileInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonFileInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonFileInfoFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonFileInfoToJSON(value?: ApiResultOfJsonFileInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonFileInfoToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

